import React from 'react';
import { HomeIcon, UsersIcon, LightbulbIcon, BarChart3Icon, ListTodoIcon, MessageSquareIcon, SettingsIcon, HelpCircleIcon } from 'lucide-react';
export const Sidebar = () => {
  const menuItems = [{
    icon: <HomeIcon size={20} data-id="element-24" />,
    label: 'Dashboard',
    active: true
  }, {
    icon: <UsersIcon size={20} data-id="element-25" />,
    label: 'Teams'
  }, {
    icon: <LightbulbIcon size={20} data-id="element-26" />,
    label: 'Insights'
  }, {
    icon: <ListTodoIcon size={20} data-id="element-27" />,
    label: 'Actions'
  }, {
    icon: <MessageSquareIcon size={20} data-id="element-28" />,
    label: 'Discussions'
  }, {
    icon: <BarChart3Icon size={20} data-id="element-29" />,
    label: 'Analytics'
  }];
  const bottomMenuItems = [{
    icon: <SettingsIcon size={20} data-id="element-30" />,
    label: 'Settings'
  }, {
    icon: <HelpCircleIcon size={20} data-id="element-31" />,
    label: 'Help'
  }];
  return <aside className="bg-white w-64 border-r border-gray-200 flex flex-col h-full" data-id="element-32">
      <div className="p-4 border-b border-gray-200" data-id="element-33">
        <h1 className="text-xl font-bold text-blue-600" data-id="element-34">Wonderflow</h1>
        <p className="text-xs text-gray-500" data-id="element-35">Collaborative Workspace</p>
      </div>
      <nav className="flex-1 p-4" data-id="element-36">
        <ul className="space-y-1" data-id="element-37">
          {menuItems.map((item, index) => <li key={index} data-id="element-38">
              <a href="#" className={`flex items-center gap-3 px-3 py-2 rounded-md text-sm ${item.active ? 'bg-blue-50 text-blue-600 font-medium' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-39">
                {item.icon}
                {item.label}
              </a>
            </li>)}
        </ul>
      </nav>
      <div className="p-4 border-t border-gray-200" data-id="element-40">
        <ul className="space-y-1" data-id="element-41">
          {bottomMenuItems.map((item, index) => <li key={index} data-id="element-42">
              <a href="#" className="flex items-center gap-3 px-3 py-2 rounded-md text-sm text-gray-700 hover:bg-gray-100" data-id="element-43">
                {item.icon}
                {item.label}
              </a>
            </li>)}
        </ul>
      </div>
    </aside>;
};